import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as SUB_COMMENT_TYPE} from '../creators/comments.subComment';

export function* createSuccess(action) {
    try {
        yield put({type: "SUB_COMMENTS_ADD", data : action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "SUB_COMMENTS_DELETE", data : action.payload});

    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "SUB_COMMENTS_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchSubComment() {
    yield takeEvery(SUB_COMMENT_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(SUB_COMMENT_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(SUB_COMMENT_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchSubComment;

